module.exports = __webpack_public_path__ + "28bca1b3.svg";